import { create } from 'zustand';
import { immer } from 'zustand/middleware/immer';
import { persist } from 'zustand/middleware';
import { AppwriteException, ID, Models, OAuthProvider } from 'appwrite';
import { account } from '@/services/appwrite/clientConfig';
import { setCookie, deleteCookie } from 'cookies-next';

export interface UserPrefs {
  mode: string;
}

interface IAuthStore {
  session: Models.Session | null;
  jwt: string | null;
  user: Models.User<UserPrefs> | null;
  hydrated: boolean;
  mode: string;

  modeChange(): Promise<void>;
  setHydrated(): void;
  verfiySession(): Promise<void>;
  login(
    email: string,
    password: string,
  ): Promise<{ success: boolean; error?: AppwriteException | null }>;
  loginByOuth2(provider: string): Promise<void>;
  createAccount(
    name: string,
    email: string,
    phone: string,
    password: string,
  ): Promise<{
    success: boolean;
    error?: AppwriteException | null;
  }>;
  logout(): Promise<boolean>;
}

export const useAuthStore = create<IAuthStore>()(
  persist(
    immer((set, get) => ({
      session: null,
      jwt: null,
      user: null,
      hydrated: false,
      setHydrated() {
        set({ hydrated: true });
      },
      mode: 'light',

      async modeChange() {
        set({ mode: get().mode === 'light' ? 'dark' : 'light' });

        if (get().user) {
          await account.updatePrefs<UserPrefs>({
            mode: get().mode,
          });
        }
      },

      async verfiySession() {
        try {
          const user = await account.get<UserPrefs>();
          const session = await account.getSession('current');
          const { jwt } = await account.createJWT();
          // console.log('verfiySession session ', session);

       // Create cookie

          setCookie('auth_token', {user,jwt}, {
            secure: true,
            expires: new Date(session.expire),
            path: '/',
          });

          // setCookie('auth_token', {user,jwt}, {
          //   secure: process.env.ENVIRONMENT === 'production',
          //   maxAge: 60 * 60 * 24, // 24 hours
          //   path: '/',
          // });

          set({ session, user, jwt });
        } catch (error) {
          console.log(error);

          throw new Error('Session verification failed');
        }
      },

      async login(email: string, password: string) {
        try {
          const session = await account.createEmailPasswordSession(
            email,
            password,
          );
          const [user, { jwt }] = await Promise.all([
            account.get<UserPrefs>(),
            account.createJWT(),
          ]);
          // console.log("auth login user ", user);

          // ✅ JWT Cookie সেট করো (Middleware থেকে এক্সেস করার জন্য)
          // setCookie('auth_token', {user,jwt}, {
          //   secure: process.env.ENVIRONMENT === 'production',
          //   maxAge: 60 * 60 * 24, // 24 hours
          //   path: '/',
          // });

          // console.log("login user ",user);
          // console.log("login session ",session);
          

          setCookie('auth_token', {user,jwt}, {
            secure: true,
            expires: new Date(session.expire),
            path: '/',
          });

          set({ session, user, jwt });

          

          return { success: true };
        } catch (error) {
          console.log(error);
          return {
            success: false,
            error: error instanceof AppwriteException ? error : null,
          };
        }
      },

      async loginByOuth2(provider: string) {
        try {
          await account.createOAuth2Session(
            provider === 'google'
              ? OAuthProvider.Google
              : OAuthProvider.Facebook,
            `${process.env.NEXT_PUBLIC_SITE_URL}/?auth=true`, // redirect here on success
            `${process.env.NEXT_PUBLIC_SITE_URL}/not-found`, // redirect here on failure
          );
          // console.log("end of loginByOuth2 ");
          
        } catch (error) {
          if(error instanceof Error){
            throw new Error(error.message);
          }else{ 
            throw new Error('Login failed');
          }
        
        }
      },

      async createAccount(
        name: string,
        email: string,
        phone: string,
        password: string,
      ) {
        try {
          // Create user account
          const registrationRes = await account.create(
            ID.unique(),
            email,
            password,
            name,
          );

     

          if (registrationRes) {
            // Log the user in immediately after registration
            const loginRes = await get().login(email, password);

            if (loginRes.success) {
              // Now that the user is authenticated, update preferences
              await account.updatePrefs({ phone });
            
            }

            return { success: true };
          }

          return { success: false };
        } catch (error) {
          
          return {
            success: false,
            error: error instanceof AppwriteException ? error : null,
          };
        }
      },

      async logout() {
        try {
          await account.deleteSessions();
          deleteCookie('auth_token', { path: '/' });
          set({ session: null, jwt: null, user: null });
          return true;
        } catch (error) {
       console.log(error);

          return false
        }
      },
    })),
    {
      name: 'better-security',
      onRehydrateStorage() {
        return (state, error) => {
          if (!error) state?.setHydrated();
        };
      },
    },
  ),
);
